import { useSyncExternalStore } from 'react';

function subscribeToPathnameChanges(callback: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {};
  }

  window.addEventListener('popstate', callback);

  return () => {
    window.removeEventListener('popstate', callback);
  };
}

function getBrowserPathname(): string {
  if (typeof window === 'undefined') {
    return '/';
  }

  return window.location.pathname;
}

export function useBrowserPathname(): string {
  return useSyncExternalStore(subscribeToPathnameChanges, getBrowserPathname, () => '/');
}
